import Category from "./category";
import {
  List as CollaboratorsList,
  Add as AddCollaborator
} from "./collaborators";
import Layout from "./Layout";
import Events from "./Events";
import ProjectExportations from "./ProjectExportations";
import Properties from "./Properties";
import Analytics from "./Analytics";
import Log from "./Log";
import Metadata from "./Metadata";
import New from "./New";
import ProjectPage from "./ProjectPage";
import Resource from "./resource";
import ResourceCollections from "./ResourceCollections";
import Resources from "./Resources";
import Text from "./text";
import Texts from "./Texts";
import Wrapper from "./Wrapper";
import Access from "./access";

export default {
  Category,
  CollaboratorsList,
  AddCollaborator,
  Layout,
  Events,
  ProjectExportations,
  Properties,
  Log,
  Analytics,
  Metadata,
  New,
  ProjectPage,
  Resource,
  ResourceCollections,
  Resources,
  Text,
  Texts,
  Wrapper,
  Access
};
